// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════
   Erica DumWae — Link-in-Bio
   Dark elegant music artist aesthetic
═══════════════════════════════════════════════ */

/* ── Page wrapper ── */
.page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: #0a0a0a;
  overflow: hidden;
}

/* Subtle horizontal rule texture */
.page::before {
  content: '';
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: repeating-linear-gradient(
    0deg,
    transparent,
    transparent 79px,
    rgba(201, 169, 110, 0.04) 79px,
    rgba(201, 169, 110, 0.04) 80px
  );
  pointer-events: none;
  z-index: 0;
}

/* Top radial glow */
.glow {
  position: fixed;
  top: -120px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 400px;
  background: radial-gradient(
    ellipse at center,
    rgba(201, 169, 110, 0.18) 0%,
    rgba(201, 169, 110, 0.06) 40%,
    transparent 70%
  );
  pointer-events: none;
  z-index: 0;
}

/* ── Content container ── */
.container {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
}

/* ── Profile section ── */
.profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

/* Rotating golden ring */
.avatar-ring {
  width: 250px;
  height: 130px;
  border-radius: 50%;
  padding: 3px;
  background: conic-gradient(
    #c9a96e 0deg,
    #f0d898 90deg,
    #8a6a30 180deg,
    #f0d898 270deg,
    #c9a96e 360deg
  );
  flex-shrink: 0;
}

@keyframes ring-spin {
  to { transform: rotate(360deg); }
}

.avatar-inner {
  width: 100%;
  height: 100%;
  /*
  border-radius: 50%;
  border: 3px solid #0a0a0a;*/
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  /*background: #141414;*/
}

.avatar-inner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.initials {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: 34px;
  font-weight: 300;
  letter-spacing: 6px;
  color: #c9a96e;
  -webkit-user-select: none;
  user-select: none;
}

/* Name */
.name {
  display:none;
  margin: 4px 0 0;
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: 30px;
  font-weight: 300;
  letter-spacing: 8px;
  color: #f0e6d3;
  text-transform: uppercase;
  text-align: center;
}

/* Gold separator */
.divider {
  width: 50px;
  height: 1px;
  background: linear-gradient(to right, transparent, #c9a96e, transparent);
  margin: 2px 0;
}

/* Subtitle */
.title {
  font-family: 'Raleway', sans-serif;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #c9a96e;
  text-align: center;
}

/* Handle */
.handle {
  font-family: 'Raleway', sans-serif;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 2px;
  color: rgba(240, 230, 211, 0.4);
}

/* ── Social icons ── */
.socials {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: 4px;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid rgba(201, 169, 110, 0.35);
  color: rgba(240, 230, 211, 0.65);
  text-decoration: none;
  transition: border-color 0.3s, color 0.3s, background 0.3s, transform 0.3s;
}

.social-link:hover {
  border-color: #c9a96e;
  color: #c9a96e;
  background: rgba(201, 169, 110, 0.1);
  transform: translateY(-3px);
}

.social-link:focus-visible {
  outline: 2px solid #c9a96e;
  outline-offset: 3px;
}

.social-link svg {
  width: 17px;
  height: 17px;
}

/* ── Description ── */
.description {
  font-family: 'Raleway', sans-serif;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.9;
  color: rgba(240, 230, 211, 0.55);
  letter-spacing: 0.4px;
  text-align: center;
  /*max-width: 360px;*/
}

/* ── Link buttons ── */
.links {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 11px;
}

.link-btn {
  position: relative;
  display: block;
  width: 100%;
  padding: 15px 28px;
  text-align: center;
  text-decoration: none;
  font-family: 'Raleway', sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 3.5px;
  text-transform: uppercase;
  color: #f0e6d3;
  border: 1px solid rgba(201, 169, 110, 0.28);
  background: rgba(201, 169, 110, 0.04);
  overflow: hidden;
  transition: border-color 0.35s, color 0.35s, background 0.35s, transform 0.25s;
}

/* Shine sweep on hover */
.link-shine {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(
    105deg,
    transparent 40%,
    rgba(201, 169, 110, 0.18) 50%,
    transparent 60%
  );
  transform: translateX(-100%);
  transition: transform 0.55s ease;
}

.link-btn:hover .link-shine {
  transform: translateX(100%);
}

.link-btn:hover {
  border-color: rgba(201, 169, 110, 0.7);
  background: rgba(201, 169, 110, 0.09);
  color: #c9a96e;
  transform: translateY(-2px);
}

.link-btn:active {
  transform: translateY(0);
}

.link-btn:focus-visible {
  outline: 2px solid #c9a96e;
  outline-offset: 3px;
}

/* ── Footer ── */
.footer {
  font-family: 'Raleway', sans-serif;
  font-size: 10px;
  font-weight: 300;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: rgba(240, 230, 211, 0.2);
  margin-top: 8px;
}

/* ── Responsive ── */
@media (max-width: 400px) {
  .name {
    font-size: 24px;
    letter-spacing: 5px;
  }

  .link-btn {
    font-size: 10px;
    letter-spacing: 2.5px;
    padding: 13px 20px;
  }
}

/* Privacy Policy */
.privacy-policy {
  min-height: 70vh;
  padding: 80px 0 60px;
  position: relative; /* enable corner overlay positioning */
}

.privacy-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px;
  background: var(--surface);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
}

.privacy-content h1 {
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 700;
  color: var(--text);
  margin: 0 0 40px;
  line-height: 1.2;
}

.privacy-content h2 {
  font-size: clamp(1.5rem, 3vw, 1.875rem);
  font-weight: 600;
  color: var(--text);
  margin: 32px 0 16px;
  line-height: 1.3;
}

.privacy-content section {
  margin-bottom: 32px;
}

.privacy-content section:last-child {
  margin-bottom: 0;
}

.privacy-content p {
  font-size: 1.0625rem;
  line-height: 1.7;
  color: var(--muted);
  margin: 16px 0;
}

.privacy-content a {
  color: var(--accent);
  text-decoration: none;
  transition: color 160ms ease;
}

.privacy-content a:hover {
  color: var(--accent-600);
  text-decoration: underline;
}

/* Diagonal CONFIDENTIAL overlay stamp in the top-right corner */
.privacy-policy .container { position: relative; }
.privacy-policy .container::after {
  content: "CONFIDENTIAL";
  position: absolute;
  top: 14px;
  right: -8px; /* slight offset so border sits at the edge */
  padding: 6px 12px;
  font-weight: 800;
  font-size: clamp(0.8rem, 1.8vw, 1rem);
  letter-spacing: 2px;
  color: #c62828;
  border: 3px solid #c62828;
  background: rgba(255, 255, 255, 0.85);
  transform: rotate(18deg);
  box-shadow: 0 6px 18px rgba(2,6,23,0.12);
  opacity: 0.92;
  text-transform: uppercase;
  pointer-events: none; /* purely decorative */
  mix-blend-mode: multiply; /* stamp-like blending */
}

@media (max-width: 768px) {
  .privacy-policy {
    padding: 60px 0 40px;
  }
  
  .privacy-content {
    padding: 24px;
    margin: 0 16px;
  }
  
  .privacy-content h1 {
    margin-bottom: 24px;
  }
  
  .privacy-content h2 {
    margin-top: 24px;
  }

  .privacy-policy .container::after {
    top: 10px;
    right: -6px;
    padding: 5px 10px;
    border-width: 2.5px;
    font-size: clamp(0.78rem, 2.6vw, 0.95rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,uBAAuB;AACvB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP;;;;;;GAMC;EACD,oBAAoB;EACpB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb;;;;;GAKC;EACD,oBAAoB;EACpB,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ;;;;;;GAMC;EACD,cAAc;AAChB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;6BAE2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,eAAe;EACf,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,WAAW;EACX,wEAAwE;EACxE,aAAa;AACf;;AAEA,aAAa;AACb;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,gCAAgC;EAChC,qBAAqB;EACrB,0EAA0E;AAC5E;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,2CAA2C;EAC3C,qCAAqC;EACrC,gBAAgB;EAChB,8EAA8E;AAChF;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP;;;;;GAKC;EACD,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,gEAAgE;AAChE,6BAA6B,kBAAkB,EAAE;AACjD;EACE,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,WAAW,EAAE,6CAA6C;EAC1D,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qCAAqC;EACrC,wBAAwB;EACxB,wCAAwC;EACxC,aAAa;EACb,yBAAyB;EACzB,oBAAoB,EAAE,sBAAsB;EAC5C,wBAAwB,EAAE,wBAAwB;AACpD;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;EAC3C;AACF","sourcesContent":["/* ═══════════════════════════════════════════════\n   Erica DumWae — Link-in-Bio\n   Dark elegant music artist aesthetic\n═══════════════════════════════════════════════ */\n\n/* ── Page wrapper ── */\n.page {\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  background: #0a0a0a;\n  overflow: hidden;\n}\n\n/* Subtle horizontal rule texture */\n.page::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: repeating-linear-gradient(\n    0deg,\n    transparent,\n    transparent 79px,\n    rgba(201, 169, 110, 0.04) 79px,\n    rgba(201, 169, 110, 0.04) 80px\n  );\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Top radial glow */\n.glow {\n  position: fixed;\n  top: -120px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 600px;\n  height: 400px;\n  background: radial-gradient(\n    ellipse at center,\n    rgba(201, 169, 110, 0.18) 0%,\n    rgba(201, 169, 110, 0.06) 40%,\n    transparent 70%\n  );\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* ── Content container ── */\n.container {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 480px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 28px;\n}\n\n/* ── Profile section ── */\n.profile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n/* Rotating golden ring */\n.avatar-ring {\n  width: 250px;\n  height: 130px;\n  border-radius: 50%;\n  padding: 3px;\n  background: conic-gradient(\n    #c9a96e 0deg,\n    #f0d898 90deg,\n    #8a6a30 180deg,\n    #f0d898 270deg,\n    #c9a96e 360deg\n  );\n  flex-shrink: 0;\n}\n\n@keyframes ring-spin {\n  to { transform: rotate(360deg); }\n}\n\n.avatar-inner {\n  width: 100%;\n  height: 100%;\n  /*\n  border-radius: 50%;\n  border: 3px solid #0a0a0a;*/\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /*background: #141414;*/\n}\n\n.avatar-inner img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.initials {\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-size: 34px;\n  font-weight: 300;\n  letter-spacing: 6px;\n  color: #c9a96e;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n/* Name */\n.name {\n  display:none;\n  margin: 4px 0 0;\n  font-family: 'Cormorant Garamond', Georgia, serif;\n  font-size: 30px;\n  font-weight: 300;\n  letter-spacing: 8px;\n  color: #f0e6d3;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n/* Gold separator */\n.divider {\n  width: 50px;\n  height: 1px;\n  background: linear-gradient(to right, transparent, #c9a96e, transparent);\n  margin: 2px 0;\n}\n\n/* Subtitle */\n.title {\n  font-family: 'Raleway', sans-serif;\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 4px;\n  text-transform: uppercase;\n  color: #c9a96e;\n  text-align: center;\n}\n\n/* Handle */\n.handle {\n  font-family: 'Raleway', sans-serif;\n  font-size: 12px;\n  font-weight: 300;\n  letter-spacing: 2px;\n  color: rgba(240, 230, 211, 0.4);\n}\n\n/* ── Social icons ── */\n.socials {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  margin-top: 4px;\n}\n\n.social-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  border: 1px solid rgba(201, 169, 110, 0.35);\n  color: rgba(240, 230, 211, 0.65);\n  text-decoration: none;\n  transition: border-color 0.3s, color 0.3s, background 0.3s, transform 0.3s;\n}\n\n.social-link:hover {\n  border-color: #c9a96e;\n  color: #c9a96e;\n  background: rgba(201, 169, 110, 0.1);\n  transform: translateY(-3px);\n}\n\n.social-link:focus-visible {\n  outline: 2px solid #c9a96e;\n  outline-offset: 3px;\n}\n\n.social-link svg {\n  width: 17px;\n  height: 17px;\n}\n\n/* ── Description ── */\n.description {\n  font-family: 'Raleway', sans-serif;\n  font-size: 13px;\n  font-weight: 300;\n  line-height: 1.9;\n  color: rgba(240, 230, 211, 0.55);\n  letter-spacing: 0.4px;\n  text-align: center;\n  /*max-width: 360px;*/\n}\n\n/* ── Link buttons ── */\n.links {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n}\n\n.link-btn {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 15px 28px;\n  text-align: center;\n  text-decoration: none;\n  font-family: 'Raleway', sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 3.5px;\n  text-transform: uppercase;\n  color: #f0e6d3;\n  border: 1px solid rgba(201, 169, 110, 0.28);\n  background: rgba(201, 169, 110, 0.04);\n  overflow: hidden;\n  transition: border-color 0.35s, color 0.35s, background 0.35s, transform 0.25s;\n}\n\n/* Shine sweep on hover */\n.link-shine {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: linear-gradient(\n    105deg,\n    transparent 40%,\n    rgba(201, 169, 110, 0.18) 50%,\n    transparent 60%\n  );\n  transform: translateX(-100%);\n  transition: transform 0.55s ease;\n}\n\n.link-btn:hover .link-shine {\n  transform: translateX(100%);\n}\n\n.link-btn:hover {\n  border-color: rgba(201, 169, 110, 0.7);\n  background: rgba(201, 169, 110, 0.09);\n  color: #c9a96e;\n  transform: translateY(-2px);\n}\n\n.link-btn:active {\n  transform: translateY(0);\n}\n\n.link-btn:focus-visible {\n  outline: 2px solid #c9a96e;\n  outline-offset: 3px;\n}\n\n/* ── Footer ── */\n.footer {\n  font-family: 'Raleway', sans-serif;\n  font-size: 10px;\n  font-weight: 300;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  color: rgba(240, 230, 211, 0.2);\n  margin-top: 8px;\n}\n\n/* ── Responsive ── */\n@media (max-width: 400px) {\n  .name {\n    font-size: 24px;\n    letter-spacing: 5px;\n  }\n\n  .link-btn {\n    font-size: 10px;\n    letter-spacing: 2.5px;\n    padding: 13px 20px;\n  }\n}\n\n/* Privacy Policy */\n.privacy-policy {\n  min-height: 70vh;\n  padding: 80px 0 60px;\n  position: relative; /* enable corner overlay positioning */\n}\n\n.privacy-content {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 40px;\n  background: var(--surface);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-lg);\n}\n\n.privacy-content h1 {\n  font-size: clamp(2rem, 4vw, 2.5rem);\n  font-weight: 700;\n  color: var(--text);\n  margin: 0 0 40px;\n  line-height: 1.2;\n}\n\n.privacy-content h2 {\n  font-size: clamp(1.5rem, 3vw, 1.875rem);\n  font-weight: 600;\n  color: var(--text);\n  margin: 32px 0 16px;\n  line-height: 1.3;\n}\n\n.privacy-content section {\n  margin-bottom: 32px;\n}\n\n.privacy-content section:last-child {\n  margin-bottom: 0;\n}\n\n.privacy-content p {\n  font-size: 1.0625rem;\n  line-height: 1.7;\n  color: var(--muted);\n  margin: 16px 0;\n}\n\n.privacy-content a {\n  color: var(--accent);\n  text-decoration: none;\n  transition: color 160ms ease;\n}\n\n.privacy-content a:hover {\n  color: var(--accent-600);\n  text-decoration: underline;\n}\n\n/* Diagonal CONFIDENTIAL overlay stamp in the top-right corner */\n.privacy-policy .container { position: relative; }\n.privacy-policy .container::after {\n  content: \"CONFIDENTIAL\";\n  position: absolute;\n  top: 14px;\n  right: -8px; /* slight offset so border sits at the edge */\n  padding: 6px 12px;\n  font-weight: 800;\n  font-size: clamp(0.8rem, 1.8vw, 1rem);\n  letter-spacing: 2px;\n  color: #c62828;\n  border: 3px solid #c62828;\n  background: rgba(255, 255, 255, 0.85);\n  transform: rotate(18deg);\n  box-shadow: 0 6px 18px rgba(2,6,23,0.12);\n  opacity: 0.92;\n  text-transform: uppercase;\n  pointer-events: none; /* purely decorative */\n  mix-blend-mode: multiply; /* stamp-like blending */\n}\n\n@media (max-width: 768px) {\n  .privacy-policy {\n    padding: 60px 0 40px;\n  }\n  \n  .privacy-content {\n    padding: 24px;\n    margin: 0 16px;\n  }\n  \n  .privacy-content h1 {\n    margin-bottom: 24px;\n  }\n  \n  .privacy-content h2 {\n    margin-top: 24px;\n  }\n\n  .privacy-policy .container::after {\n    top: 10px;\n    right: -6px;\n    padding: 5px 10px;\n    border-width: 2.5px;\n    font-size: clamp(0.78rem, 2.6vw, 0.95rem);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
